import React from 'react';
import QuestionnaireContainer from './QuestionnaireContainer';

const Questionnaire = (props) => (
  <QuestionnaireContainer {...props} />
)

export default Questionnaire;


// WEBPACK FOOTER //
// src/routes/Questionnaire/index.js